/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientRefResponse } from './';
import {
    ClientRefResponseFromJSON,
    ClientRefResponseFromJSONTyped,
    ClientRefResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientRefsInCompanyResponse
 */
export interface ClientRefsInCompanyResponse {
    /**
     * 
     * @type {Array<ClientRefResponse>}
     * @memberof ClientRefsInCompanyResponse
     */
    clients: Array<ClientRefResponse>;
}

/**
 * Check if a given object implements the ClientRefsInCompanyResponse interface.
 */
export function instanceOfClientRefsInCompanyResponse(value: object): value is ClientRefsInCompanyResponse {
    if (!('clients' in value) || value['clients'] === undefined) return false;
    return true;
}

export function ClientRefsInCompanyResponseFromJSON(json: any): ClientRefsInCompanyResponse {
    return ClientRefsInCompanyResponseFromJSONTyped(json, false);
}

export function ClientRefsInCompanyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientRefsInCompanyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clients': ((json['clients'] as Array<any>).map(ClientRefResponseFromJSON)),
    };
}

export function ClientRefsInCompanyResponseToJSON(value?: ClientRefsInCompanyResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clients': ((value['clients'] as Array<any>).map((v) => ClientRefResponseToJSON(v))),
    };
}

